@if (!skipAvatar) {
  @if      (loading           ) { <div class="loading-animate ma-mobile" [class.circle-100]="  useCase !== 'e'"    [class.circle-170]="useCase === 'e'"></div> }
  @else if (entry?.avatarImage) { <img class="circle-170      ma-mobile" [class.hover-active]="detailsAvailable()" [src]="entry.avatarImage"             (click)="openExternalDetails()" /> }
  @else                         { <div class="header-avatar   ma-mobile" [class.hover-active]="detailsAvailable()" [class.tablet-hide]="useCase !== 'e'" (click)="openExternalDetails()"></div> }
}
  
@if (headerItems?.length || headerTabs?.length) {
  <div class="am-flex-column gap-xxs text-s ml-xxs-mobile">
    @if (loading) { <span class="loading-animate height-18 width-200"></span> }
    @else         {
      @if (customHeader) { <h2 class="text-xl bold m0 ml-xs-mobile height-18">{{ customHeader }}</h2> }
      @else              {
        <div class="am-flex-align gap-s">
          <h2 class="text-xl bold m0 ml-xs-mobile color-blue" [class.hover-active]="detailsAvailable()" (click)="openExternalDetails()">{{ getName() }}</h2>
          @if (secondaryTitle) { <span class="bg-light-blue b-radius-wide pt-xxs pb-xxs pl-xs pr-xs font-s word-no-wrap color-blue">{{ secondaryTitle }}</span> }
        </div>
      }
    }

    @if (subtitle?.length) {
      <div class="am-flex-column pt-xxxs pb-xxxs">
        @for (item of subtitle; track $index) { <ng-container *ngTemplateOutlet="headerItem; context: { item }"></ng-container> }
      </div>
    }

    @if (headerTabs?.length) {
      <div class="am-flex-align gap-m mb-xs">
        @for (tab of headerTabs; track $index) { <span class="pb-xxxs font-l font-500 hover-active" [ngClass]="tab.active ? 'color-blue bb-blue-2' : 'bb-white-2'" (click)="selectTab(tab)">{{ tab.label }}</span> }
      </div>
      <div class="grid-stack">
        @for (tab of headerTabs; track $index) {
          <div class="am-flex-column gap-xxs" [class.invisible]="!tab.active">
            @for (item of tab.children; track $index) { <ng-container *ngTemplateOutlet="headerItem; context: { item }"></ng-container> }
          </div>
        }
      </div>
    } @else {
      @for (item of headerItems; track $index) { <ng-container *ngTemplateOutlet="headerItem; context: { item }"></ng-container> }
    }
  </div>
}

<ng-template #headerItem let-item="item">
  <div class="am-flex-align gap-xxs" [ngClass]="item?.class">
    @if (item) {
      <span class="am-flex-center text-l" [ngClass]="item.icon"></span>
      @if (item.label)                    { <span class="lh-1">{{ item.label }}:</span>                            }
      @if (item.value || item.valueClass) { <span class="lh-1" [ngClass]="item.valueClass">{{ item.value }}</span> }
      @if (item.children?.length)         {
        <span [ngClass]="item.childrenClass">
          @for (child of item.children; track $index) {
            <span [ngClass]="child.class">
              <span [ngClass]="child.class">{{ child.value }}</span>
              @for (grandchild of child.children; track $index) { <span [ngClass]="grandchild.class">{{ grandchild.value }}</span> }
            </span>
          }
        </span>
      }
    }
    @else {
      <span class="loading-animate height-m width-m"  ></span>
      <span class="loading-animate height-m width-250"></span>
    }
  </div>
</ng-template>
